import { Users } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RiderCountProps {
  count: number;
  maxParticipants?: number;
  waitlistCount?: number;
  showCapacity?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function RiderCount({
  count,
  maxParticipants,
  waitlistCount,
  showCapacity = true,
  size = 'md',
  className,
}: RiderCountProps) {
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg font-medium',
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
  };

  const formatCount = () => {
    if (count === 0) return 'No riders yet';
    if (count === 1) return '1 rider going';

    if (showCapacity && maxParticipants) {
      if (count >= maxParticipants) {
        return `Ride Full (${count} of ${maxParticipants} riders)`;
      }
      return `${count} of ${maxParticipants} riders going`;
    }

    return `${count} riders going`;
  };

  return (
    <div className={cn('text-adv-lightGray flex items-center gap-2', sizeClasses[size], className)}>
      <Users className={cn('text-adv-orange', iconSizes[size])} />
      <span>{formatCount()}</span>
      {waitlistCount !== undefined && waitlistCount > 0 && (
        <span className="text-adv-mediumGray">({waitlistCount} waitlisted)</span>
      )}
    </div>
  );
}
